<template>
    <header>
        <div class="topbar">
            <div class="wrapper">
                <img class="topbar__image" :src="topBarImage" alt="Clio Muse Tours logo">
            </div>
        </div>
        <LanguageSelector/>
    </header>
    <main>
        <div class="wrapper" style="margin-top: 4rem; margin-bottom: 4rem;">
            <Error500 v-if="error.statusCode === 500" :error="error"/>
            <Error404 v-else-if="error.statusCode === 404" :error="error"/>
        </div>
    </main>
    <Footer/>
</template>

<script>
    import Error404 from '~/components/error/error-404.vue';
    import Error500 from '~/components/error/error-500.vue';
    import Footer from './components/Footer.vue';
    import LanguageSelector from './components/common/LanguageSelector.vue';

    export default {
        name: 'nuxt-error',
        components: {
        Error404,
        Error500,
        Footer,
        LanguageSelector
        },
        setup() {
            const error = useError();
        },
        props: {
            error: {
                type: Object,
                default: () => {},
            }
        },
        data() {
            return {
                topBarImage: '/icons/clio-muse-tours-logo-white.svg'
            }
        }
    }
</script>